export enum DocumentInstanceRoles {
  VIEWER = 'roles.documentInstanceViewer',
  CREATOR = 'roles.documentInstanceCreator',
  ARCHIVER = 'roles.documentInstanceArchiver',
  UPDATER = 'roles.documentInstanceUpdater',
}
